var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ECB32C",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 23.75C29.4375 23.75 30 24.3125 30 25C30 25.6875 29.4375 26.25 28.75 26.25C28.0625 26.25 27.5 25.6875 27.5 25C27.5 24.3125 28.0625 23.75 28.75 23.75ZM28.75 21.25C26.675 21.25 25 22.925 25 25C25 27.075 26.675 28.75 28.75 28.75C30.825 28.75 32.5 27.075 32.5 25C32.5 22.925 30.825 21.25 28.75 21.25ZM17.5 12.5H11.25V15H17.5V12.5ZM26.25 11.25H22.5V13.75H26.25V17.0625L21.875 22.5H17.5V16.25H12.5C9.7375 16.25 7.5 18.4875 7.5 21.25V25H10C10 27.075 11.675 28.75 13.75 28.75C15.825 28.75 17.5 27.075 17.5 25H23.125L28.75 17.9375V13.75C28.75 13.087 28.4866 12.4511 28.0178 11.9822C27.5489 11.5134 26.913 11.25 26.25 11.25ZM13.75 26.25C13.0625 26.25 12.5 25.6875 12.5 25H15C15 25.6875 14.4375 26.25 13.75 26.25Z",
    fill: "#ECB32C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery-icon.3ab7f66e8ad57367c589ad817f78b1c7.svg";
export { ForwardRef as ReactComponent };